<!-- 推荐盘源 -->
<template>
  <div id="addRecommend">
    <a-form-model ref="form" :model="saveVO.recommendDO">

      <div class="greyDiv">

        <!-- 主推荐 -->
        <div style='display: flex;justify-content: space-between;margin-bottom: 10px;margin-left: 10px'>

          <div style="display: flex">
            <div @click="clickRecommend(1)" :class=" choiceRecommend === 1 ?  'choice_label_active' : 'choice_label'">
              <div>{{ $t('keypanyuan') }}</div>
              <div :class=" choiceRecommend === 1 ?  'choice_div_active' : 'choice_div'"></div>
            </div>

            <div @click="clickRecommend(2)" :class=" choiceRecommend === 2 ?  'choice_label_active ml_30' : 'choice_label ml_30' ">
              <div>{{ $t('key9qita') }}</div>
              <div :class=" choiceRecommend === 2 ?  'choice_div_active' : 'choice_div'"></div>
            </div>

          </div>


          <a-checkbox v-model:checked="saveVO.recommendDO.mainRecommend" :disabled =" mainBuildingFlag ? true : false  " >{{$t('deal.recommend.mainRecommend')}}</a-checkbox>
        </div>


        <a-row class='top-ant'>
          <!-- 大厦 -->
          <a-col :span="8">
            <a-form-model-item v-if="choiceRecommend === 1" :rules="[
                                   {required: true,message: $t('vacantInformation.modal.selectMansionTip'),},
                ]" :label="$t('hkunit.add.building')" prop="mansionId" class="required">

              <a-select

                v-model="saveVO.recommendDO.mansionId"
                :placeholder="$t('vacantInformation.modal.selectMansionTip')"
                showSearch
                :defaultActiveFirstOption="false"
                :filterOption="false"
                @search="initMansionOptions"
                option-label-prop="label"
                @change="initMansionFloorOptions"
              >
                <a-icon slot="suffixIcon" type="caret-down"/>
                <a-select-option v-for="m in mansionOptions" :key="m.id" :label="m.nameEn == '~'?m.name:m.nameEn" :value="m.id">
                  <div>
                    <div>{{m.nameEn == '~'?m.name:m.nameEn}}</div>
                    <div>{{m.name}}</div>
                  </div>
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item  v-else :rules="[
                                   {required: true,message: $t('vacantInformation.modal.enterMansionTip'),},
                ]" :label="$t('hkunit.add.building')" prop="otherMansionName" class="required">
              <a-input :placeholder="$t('deal.recommend.enter')"  v-model="saveVO.recommendDO.otherMansionName" ></a-input>
            </a-form-model-item>

          </a-col>


          <!-- 所在楼层 -->
          <a-col :span="8">
            <a-form-model-item v-if="choiceRecommend === 1" class="required" :label="$t('deal.recommend.floor')" prop='floorId'
                               :rules="[{required: true,message: $t('baseVO.selectPlaceholder'),},]"
            >
              <pt-select
                @change="floorChange"
                :allow-clear='false'
                v-model='floorId'
                :showSearch="true"
                :placeholder="$t('lease.modal.selectTip')"
              >
                <a-select-option v-for="f in floorOptions" :key="f.id" :value="f.id">{{f.floorNum}}F</a-select-option>
              </pt-select>
            </a-form-model-item>

            <a-form-model-item  v-else :rules="[
                                   {required: true,message: $t('vacantInformation.modal.enterFloorTip'),},
                ]" :label="$t('deal.recommend.floor')" prop="otherFloorName" class="required">
              <a-input :placeholder="$t('deal.recommend.enter')"  v-model="saveVO.recommendDO.otherFloorName" ></a-input>
            </a-form-model-item>
          </a-col>


          <!-- 单元号 -->
          <a-col :span="8">
            <a-form-model-item v-if=" choiceRecommend === 1" class="required" :label="$t('deal.recommend.unit')" prop='unitId'
                               :rules="[{required: true,message: $t('baseVO.selectPlaceholder'),},]" >
              <pt-select
                @change="unitChange"
                :allow-clear='false'
                v-model='unitId'
                :showSearch="true"
                :placeholder="$t('lease.modal.selectTip')"
              >
                <a-select-option v-for="f in unitOptions" :key="f.id" :value="f.id">{{f.unit}}</a-select-option>
              </pt-select>
            </a-form-model-item>

            <a-form-model-item  v-else :rules="[
                                   {required: true,message: $t('vacantInformation.modal.enterUnitCodeTip'),},
                ]" :label="$t('deal.recommend.unit')" prop="otherUnitName" class="required">
              <a-input :placeholder="$t('deal.recommend.enter')"  v-model="saveVO.recommendDO.otherUnitName" ></a-input>
            </a-form-model-item>

          </a-col>



        </a-row>

        <div v-if='showUnit' class='show_unit'>
          <a-row>
            <a-col :span="6">{{$t('deal.recommend.area')}}{{unitDetail.area}}</a-col>
            <a-col :span="6">{{$t('deal.recommend.netFloorArea')}}{{unitDetail.netFloorArea}}</a-col>
            <a-col :span="6">{{$t('deal.recommend.askingRent')}}${{unitDetail.askingRent}}</a-col>
            <a-col :span="6">{{$t('deal.recommend.mthlyAskingRent')}}${{unitDetail.mthlyAskingRent}}</a-col>
          </a-row>
        </div>



        <a-row>

          <!-- 最新面价 -->
          <a-col :span="8">
            <a-form-model-item :label="$t('deal.recommend.newRent')" >
              <a-input-group compact>
                <a-input-number :placeholder="$t('deal.recommend.enter')" :precision="2" style="width:45%;" v-model="saveVO.recommendDO.newRent" :max="99999" :min="0"
                ></a-input-number>
                <pt-unit-select :showArrow="false" style="width: 55%;" type="rent" v-model="budgetRentUnit" disabled></pt-unit-select>
              </a-input-group>
            </a-form-model-item>
          </a-col>

          <!-- 免租期 -->
          <a-col :span="8">
            <a-form-model-item  :label="$t('deal.recommend.freeLeaseTermMonth')">
              <a-input-number style="font-size: 12px;width:100%;" :placeholder="$t('deal.recommend.enter')"
                              v-model="saveVO.recommendDO.freeLeaseTerm"  :max="999" :min="0"  :precision="1"></a-input-number>
            </a-form-model-item>
          </a-col>

          <!-- 租期 -->
          <a-col :span="8">
            <a-form-model-item  :label="$t('deal.recommend.leaseTermMonth')">
              <a-input-number :placeholder="$t('deal.recommend.enter')"
                              style="font-size: 12px;width:100%;" v-model="saveVO.recommendDO.leaseTerm" :max="999" :min="0.1" :precision="1"></a-input-number>
            </a-form-model-item>
          </a-col>
          <!-- 预计起租日期 -->
          <a-col :span="8">
            <a-form-model-item  :label="$t('deal.recommend.startDate')">
              <a-date-picker :placeholder="$t('deal.recommend.select')"

                             style="width:100%;" value-format="YYYY-MM-DD" v-model="saveVO.recommendDO.startDate"  ></a-date-picker>
            </a-form-model-item>
          </a-col>


        </a-row>

        <a-row>

          <!-- 备注 -->
          <a-col :span="24">
            <a-form-model-item :colon="false" :label="$t('residentProjects.addDeal.brokerage.remarks')">
              <a-input :placeholder="$t('deal.recommend.remarks')" :maxLength="512" v-model="saveVO.recommendDO.remarks" type="textarea"
                       :autosize="{minRows:4,maxRows:4}"></a-input>
            </a-form-model-item>
          </a-col>

        </a-row>


      </div>
    </a-form-model>


    <pt-modal :title="$t('mansion.addMansion.addTitle')" :visible="addMansionVisible"
              @ok="addMansion" @cancel="cancelAddMansion" :width="800"
    >
      <div slot="content">
        <quickly-add-mansion cityValue="香港" ref="addMansionRef" @saveSuccess="saveMansionSuccess"></quickly-add-mansion>
      </div>
    </pt-modal>


  </div>
</template>

<script>
import mansionApi from '@/api/database/mansion'
import quicklyAddMansion from '@/views/database/mansionData/quicklyAddMansion'
import mansionFloorApi from '@/api/database/mansionFloor'
import stockApi from '@/api/database/stock'
import dealRecommendBuildingApi from '@/api/mine/dealRecommendBuilding'

export default {
  name: 'addRecommend',
  components:{
    quicklyAddMansion,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },

  },
  props:{
    dealId: null,
  },

  data(){
    return{

      floorId:undefined,
      unitId:undefined,

      mainBuildingFlag: false,
      choiceRecommend:1,
      addMansionVisible:false,
      budgetRentUnit:'HK$/SQFT/MTH',
      showUnit:false,

      saveVO:{
        recommendDO:{
          mansionId:undefined,
          floorId:undefined,
          unitId:undefined,
          mainRecommend:false,
          newRent:undefined,
          freeLeaseTerm:undefined,
          startDate:undefined,
          leaseTerm:undefined,
          remarks:undefined,
          dealId:this.dealId,
          type:1,
          otherMansionName:undefined,
          otherFloorName:undefined,
          otherUnitName:undefined
        }
      },

      unitDetail:{
        area:undefined,
        netFloorArea:undefined,
        askingRent:undefined,
        mthlyAskingRent:undefined
      },

      floorOptions:[],
      unitOptions:[],
      mansionOptions:[],
    }
  },

  mounted() {

    this.initData()

  },

  methods:{

    clickRecommend(val){
      this.$refs.form.clearValidate()
      this.$refs.form.resetFields()
      this.floorId = undefined
      this.saveVO = {
        recommendDO:{
          mansionId:undefined,
          floorId:undefined,
          unitId:undefined,
          mainRecommend:false,
          newRent:undefined,
          freeLeaseTerm:undefined,
          leaseTerm:undefined,
          remarks:undefined,
          startDate:undefined,
          dealId:this.dealId,
          type:1,
          otherMansionName:undefined,
          otherFloorName:undefined,
          otherUnitName:undefined
        }
      }
      this.showUnit = false;
      this.unitId = undefined
      this.unitDetail = {
        area:undefined,
          netFloorArea:undefined,
          askingRent:undefined,
          mthlyAskingRent:undefined
      }
      this.choiceRecommend = val
      this.initData()
    },


    //判断该交易下是否有推荐盘源，没有的话，当前新增的推荐盘源自动为主推荐盘源
    initData(){
      dealRecommendBuildingApi.checkRecommend(this.dealId).then(res=>{
        if(res.code == 1){
          this.mainBuildingFlag = res.data
          if(res.data){
            this.saveVO.recommendDO.mainRecommend = true
          }
        }
      })



    },



    addMansion(){

    },
    cancelAddMansion(){
      this.addMansionVisible = false
    },
    saveMansionSuccess(mansionId,mansionName){

      this.addMansionVisible = false;
    },

    mansionIdChange(mansionId){
      this.saveVO.recommendDO.mansionId = mansionId
      this.initMansionFloorOptions(mansionId);
    },
    floorChange(value){
      let floorInfo = this.floorOptions.find(o=>{return o.id == value})
      this.saveVO.recommendDO.floorId = floorInfo.floorNum
      this.initMansionUnitOptions(value);
    },
    unitChange(value){
      this.showUnit = false
      let unitInfo = this.unitOptions.find(o=>{return o.id == value})
      this.saveVO.recommendDO.unitId = unitInfo.id
      this.initUnit(unitInfo);
    },


    initUnit(unitInfo){
      this.showUnit = true
      this.unitDetail = {
        area: unitInfo.area,
        netFloorArea: unitInfo.netFloorArea,
        askingRent: unitInfo.askingRent,
        mthlyAskingRent: unitInfo.mthlyAskingRent
      }
    },

    initMansionFloorOptions(mansionId){
      this.floorId = undefined
      this.unitId = undefined
      this.showUnit = false
      if(mansionId){
        mansionFloorApi.listByMansionId(mansionId).then(res=>{
          if(res.code == 1){
            this.floorOptions = res.data;
          }
        })
      }
    },

    initMansionUnitOptions(floorId){
      this.unitId = undefined
      this.showUnit = false
      let stock = {
        mansionId:this.saveVO.recommendDO.mansionId,
        floorId:floorId
      }
      stockApi.listUnit(stock).then(res=>{
        if(res.code == 1){
          this.unitOptions = res.data
        }

      })
    },


    initMansionOptions(value){
      if (value == null || value == '') {
        return
      }
      mansionApi.listAll({ queryText: value,city:'HK' }).then(res => {
        if (res.code == 1) {
          this.mansionOptions = res.data
        }
      })
    },

    openAddMansionModal(){
      this.addMansionVisible = true;
    },


    submit(){
      let _this = this;
      this.$refs.form.validate(err=> {
        if (err) {
          _this.execSave()
        }else{
          _this.$emit('validateFail')
        }

      });
    },

    execSave(){
      let _this = this;

      let freeLeaseTerm = _this.saveVO.recommendDO.freeLeaseTerm
      let leaseTerm = _this.saveVO.recommendDO.leaseTerm
      if(freeLeaseTerm > leaseTerm){
        this.$message.error(_this.$t('deal.recommend.termTips'))
        _this.$emit('validateFail')
        return
      }

      let recommendDO = _this.saveVO.recommendDO
      recommendDO.type = this.choiceRecommend
      console.log('recommendDO',recommendDO)
      dealRecommendBuildingApi.insert(recommendDO).then(res=>{
        if (res.code == 1){
          this.$message.success(res.message)
          _this.$emit('saveRecommendSuccess')
        }else{
          _this.$emit('validateFail')
        }
      })

    }




  }



}
</script>

<style scoped lang="less">

.addBottomBtn{
  background: #3B2E26;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 30px;
  .addIcon{
    color: #ffffff;
    font-size: 12px;
  }
  .addBtnText{
    font-size: 12px;
    color: #ffffff;
    margin-left:4px;
  }
}

#addRecommend {
  .greyDiv {
    padding: 20px;
    background: rgba(248, 249, 251, 0.62);
    border-radius: 0 0 4px 4px;
  }
  .ant-form-item{
    padding: 0 10px;
  }

}

form .ant-mentions, form textarea.ant-input{
  background-color: #FFFFFF !important;
}

.show_unit{
  width: 690px;
  height: 50px;
  background: #F2F2F3;
  border-radius: 4px;
  margin-left: 10px;
  padding: 18px 15px;
  font-size: 12px;
  color: #333333;
  font-weight: 600;
}


.choice_label_active{
  cursor: pointer;
  font-size: 12px;
  color: #333333;
  font-weight: 600;
}

.choice_label{
  cursor: pointer;
  font-size: 12px;
  color: #979797;
  font-weight: 600;
}
.ml_30{
  margin-left: 30px;
}
.choice_div_active{
  background: #FABE00;
  height: 4px;
}



.top-ant .ant-form-item{
  margin-bottom: 4px !important;
}


</style>